import { render, staticRenderFns } from "./tableWrap.vue?vue&type=template&id=9b027eae&scoped=true&"
import script from "./tableWrap.vue?vue&type=script&lang=js&"
export * from "./tableWrap.vue?vue&type=script&lang=js&"
import style0 from "./tableWrap.vue?vue&type=style&index=0&id=9b027eae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b027eae",
  null
  
)

export default component.exports